import React, { useState } from 'react';
import { Modal, Checkbox, Button } from 'antd';
import { api, apis, getIn18Text } from 'api';
import { ReactComponent as CloseIcon } from '@/images/icons/close_modal.svg';
import styles from './index.module.scss';
const loginApi = api.requireLogicalApi(apis.loginApiImpl);
const JumpOutModal = ({ visible, onJumpOutCancel, onJumpOutConfirm }) => {
    const [ignore, setIgnore] = useState(false);
    const onChange = (e) => {
        const isIgnore = e.target.checked;
        setIgnore(isIgnore);
    };
    const onClose = async (confirm) => {
        if (ignore) {
            try {
                await loginApi.setEntrancePopupVisible(confirm ? '点击立即体验' : '勾选下次不再提醒');
            }
            catch (error) {
                console.error('setEntrancePopupVisible error', error);
            }
        }
        if (confirm) {
            onJumpOutConfirm();
        }
        else {
            onJumpOutCancel();
        }
    };
    return (React.createElement(Modal, { visible: visible, width: 640, closeIcon: React.createElement(CloseIcon, { className: "dark-invert" }), bodyStyle: {
            padding: '20px 20px 0',
        }, onCancel: () => onClose(false), footer: null },
        React.createElement("div", { className: styles.container },
            React.createElement("div", { className: styles.title }, getIn18Text('JUMP_OUT_MODAL_TITLE')),
            React.createElement("div", { className: styles.intro }, getIn18Text('JUMP_OUT_MODAL_INTRO')),
            React.createElement("div", { className: styles.itemList },
                React.createElement("div", { className: styles.item },
                    React.createElement("div", { className: styles.icon }),
                    React.createElement("p", { className: styles.text }, getIn18Text('JUMP_OUT_MODAL_ITEM1'))),
                React.createElement("div", { className: styles.item },
                    React.createElement("div", { className: styles.icon }),
                    React.createElement("p", { className: styles.text }, getIn18Text('JUMP_OUT_MODAL_ITEM2'))),
                React.createElement("div", { className: styles.item },
                    React.createElement("div", { className: styles.icon }),
                    React.createElement("p", { className: styles.text }, getIn18Text('JUMP_OUT_MODAL_ITEM3'))),
                React.createElement("div", { className: styles.item },
                    React.createElement("div", { className: styles.icon }),
                    React.createElement("p", { className: styles.text }, getIn18Text('JUMP_OUT_MODAL_ITEM4')))),
            React.createElement("div", { className: styles.footer },
                React.createElement("div", { className: styles.ignoreItem },
                    React.createElement(Checkbox, { checked: ignore, onChange: onChange },
                        React.createElement("span", { className: styles.checkboxText }, getIn18Text('BUZAITIXING')))),
                React.createElement("div", { className: styles.buttonItem },
                    React.createElement(Button, { className: styles.cancelBtn, onClick: () => onClose(false) }, getIn18Text('SHAOHOUZAIKAN')),
                    React.createElement(Button, { className: styles.confirmBtn, onClick: () => onClose(true), type: "primary" }, getIn18Text('LIJISHIYONG')))))));
};
export default JumpOutModal;
